import { render, staticRenderFns } from "./CgformAutoListButtons.vue?vue&type=template&id=34c743de&scoped=true&"
import script from "./CgformAutoListButtons.vue?vue&type=script&lang=js&"
export * from "./CgformAutoListButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c743de",
  null
  
)

export default component.exports